export default __webpack_public_path__ + "roboto-v27-latin-700.0344cc3c5cd0959f5f92fdb3d8168fed.woff";